import type { ReactElement } from 'react';
import { Line, ReferenceLine } from 'recharts';
import { getConstantGoalLines, getVaryingGoalKeys } from './chartGoalUtils';
import { CHART_GOAL_LINE_COLOR, CHART_GOAL_LINE_PROPS } from './constants';

/** Render goal lines as direct Recharts children (must not be wrapped in a custom component). */
export function renderChartGoalLines(
  chartData: Record<string, unknown>[],
  valueKeys: string[]
): ReactElement[] {
  const constantGoals = getConstantGoalLines(chartData, valueKeys);
  const varyingGoalKeys = getVaryingGoalKeys(chartData, valueKeys);

  return [
    ...Object.entries(constantGoals).map(([key, y]) => (
      <ReferenceLine
        key={`goal-ref-${key}`}
        y={y}
        stroke={CHART_GOAL_LINE_COLOR}
        strokeWidth={CHART_GOAL_LINE_PROPS.strokeWidth}
        strokeDasharray={CHART_GOAL_LINE_PROPS.strokeDasharray}
        ifOverflow="extendDomain"
      />
    )),
    ...varyingGoalKeys.map((key) => (
      <Line
        key={`goal-line-${key}`}
        type="monotone"
        dataKey={`${key}__goal`}
        stroke={CHART_GOAL_LINE_COLOR}
        strokeWidth={CHART_GOAL_LINE_PROPS.strokeWidth}
        strokeDasharray={CHART_GOAL_LINE_PROPS.strokeDasharray}
        fill="none"
        dot={false}
        connectNulls
        isAnimationActive={false}
        legendType="none"
      />
    )),
  ];
}
